// Copyright © 2021 Move Closer
import { computed } from '@vue/composition-api';
import { DashmixBoxModeMap } from './Box.contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const dashmixBoxProps = {
    bodyClass: {
        type: String,
        required: false,
        default: ''
    },
    footerClass: {
        type: String,
        required: false,
        default: ''
    },
    footerMode: {
        type: String,
        required: false,
        default: () => DashmixBoxModeMap.Clean
    },
    headerClass: {
        type: String,
        required: false,
        default: ''
    },
    headerMode: {
        type: String,
        required: false,
        default: () => DashmixBoxModeMap.Clean
    },
    noBodyPadding: {
        type: Boolean,
        required: false,
        default: false
    },
    shadow: {
        type: Boolean,
        required: false,
        default: false
    }
};
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function useDashmixBox(props, ctx) {
    const isFooterDivided = computed(() => {
        return props.footerMode === DashmixBoxModeMap.Divided;
    });
    const isHeaderDivided = computed(() => {
        return props.headerMode === DashmixBoxModeMap.Divided;
    });
    const bodyPaddingClass = computed(() => {
        if (props.noBodyPadding) {
            return 'p-0';
        }
        const classes = [];
        if (isFooterDivided) {
            classes.push('block-content-full');
        }
        return classes.join(' ');
    });
    return { bodyPaddingClass, isFooterDivided, isHeaderDivided };
}
